import { useLocalZonePreference } from '@/hooks/useLocalZonePreference';
import { Source, SOURCE_TYPE_DISPLAY_NAMES } from '@/types/evals';
import { formatTimestamp } from '@/utils/timeFormatter';

import { InfoCard } from '../../_components/InfoCard';
import { InfoCardRow } from '../../_components/InfoCardRow';

type Props = {
  source: Source;
};

export function MetaRow( { source }: Props ) {
  const [ useLocalZone ] = useLocalZonePreference();

  return (
    <InfoCardRow data-testid="version-meta-row">
      <InfoCard label="Source Type" value={ SOURCE_TYPE_DISPLAY_NAMES[source.source_type] } />
      <InfoCard label="Example Count" value={ source.example_count ?? '—' } />
      <InfoCard label="Example Type" value={ source.example_type } />
      <InfoCard label="Last Sync" value={ formatTimestamp( source.last_sync, useLocalZone ) } />
    </InfoCardRow>
  );
}
